import { render, staticRenderFns } from "./EventDetailsRecurrenceForm.vue?vue&type=template&id=67f5dd05&scoped=true&"
import script from "./EventDetailsRecurrenceForm.vue?vue&type=script&lang=js&"
export * from "./EventDetailsRecurrenceForm.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailsRecurrenceForm.vue?vue&type=style&index=0&id=67f5dd05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5dd05",
  null
  
)

export default component.exports